"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OSMOSYS_BUTTON_PRESETS = {
    blockOverlay: {
        className: 'm-1',
        color: 'dark',
        size: 'lg',
    },
    blockToolbar: {
        activeClassName: 'text-primary',
        className: 'p-0',
        color: 'link',
        iconSize: 'lg',
        inactiveClassName: 'text-primary',
    },
    blockToolbarDanger: {
        activeClassName: 'text-danger',
        className: 'p-0',
        color: 'link',
        iconSize: 'lg',
        inactiveClassName: 'text-danger',
    },
    default: {
        color: 'primary',
    },
    inline: {
        className: 'text-reset p-0 d-inline',
        color: 'link',
    },
    link: {
        className: 'p-0',
        color: 'link',
    },
    navLink: {
        color: 'link',
    },
    outline: {
        outline: true,
    },
    plain: {
        className: 'text-reset',
        color: 'link',
    },
    save: {
        color: 'success',
        iconPosition: 'left',
        iconStyle: 'solid',
    },
    selectIndicator: {
        className: 'text-muted p-0 ml-0 my-0 mr-1 h-100 d-block flex-col-centered',
        color: 'link',
        flexColCenteredTooltip: true,
        iconFixedWidth: true,
        iconStyle: 'solid',
        size: 'sm',
    },
    toolbar: {
        activeClassName: 'text-primary',
        className: 'p-2',
        color: 'link',
        iconSize: 'lg',
        inactiveClassName: 'text-dark',
    },
};
//# sourceMappingURL=constants.js.map